import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

const CreditCard = createSvgIcon(
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 10H21.5M7.5 15H8.5M12.5 15H13.5M6.5 19H18.5C19.2956 19 20.0587 18.6839 20.6213 18.1213C21.1839 17.5587 21.5 16.7956 21.5 16V8C21.5 7.20435 21.1839 6.44129 20.6213 5.87868C20.0587 5.31607 19.2956 5 18.5 5H6.5C5.70435 5 4.94129 5.31607 4.37868 5.87868C3.81607 6.44129 3.5 7.20435 3.5 8V16C3.5 16.7956 3.81607 17.5587 4.37868 18.1213C4.94129 18.6839 5.70435 19 6.5 19Z"
      stroke="#009FB8"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>,
  "CreditCard"
);

export default CreditCard;
